import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Root.jsx';
import reportWebVitals from './reportWebVitals';

import './styles/all.css';
import './styles/uikit.css';
import './styles/uikit-rtl.css';
import './styles/om.css';
import './lib/uikit.js';

ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
